module.exports = __webpack_public_path__ + "static/media/tv-alt.4b65be9a.svg";